import React from "react";
import Layout from "../components/layout";
import MouseJump from "../components/MouseJump";
import CountDown from "../sections/Countdown";
import FAQs from "../sections/FAQs";
import Genders from "../sections/Genders";
import Hero from "../sections/Hero";
import Minted from "../sections/Minted";
import Mission from "../sections/Mission";
import MissionVines from "../sections/MissionVines";
import OurTeam from "../sections/OurTeam";
import Roadmap from "../sections/Roadmap";
import Sanctuary from "../sections/Sanctuary";
import SlothSlider from "../sections/SlothSlider";
import Utilities from "../sections/Utilities";


function Index({ pageContext, location }) {


  return (
    <Layout location={location}>

      <Hero/>
      <Minted/>
      <Sanctuary/>
      <Mission/>
      <MissionVines/>
      <Genders/>
      <Utilities/>
      <Roadmap/>

      <SlothSlider/>
      <OurTeam/>
      <MissionVines/>
      <FAQs/>
    
    </Layout>
  );
}

export default Index;
